/**
 * 密码加密工具函数
 */
import md5 from 'js-md5'

/**
 * 对密码进行MD5加密
 * @param {string} password - 明文密码
 * @returns {string} 加密后的密码
 */
export function encryptPassword(password) {
  if (!password) {
    return ''
  }
  // 使用MD5加密密码
  return md5(password)
}

/**
 * 对登录表单数据进行处理，加密密码字段
 * @param {Object} loginData - 登录表单数据
 * @returns {Object} 处理后的数据
 */
export function processLoginData(loginData) {
  if (!loginData || !loginData.password) {
    return loginData
  }

  return {
    ...loginData,
    password: encryptPassword(loginData.password)
  }
}

/**
 * 对注册表单数据进行处理，加密密码字段
 * @param {Object} registerData - 注册表单数据
 * @returns {Object} 处理后的数据
 */
export function processRegisterData(registerData) {
  if (!registerData || !registerData.password) {
    return registerData
  }
  return {
    ...registerData,
    password: encryptPassword(registerData.password),
    // 确认密码也需要加密（虽然服务器通常只验证password字段）
    confirmPassword: encryptPassword(registerData.confirmPassword),
    newPassword: encryptPassword(registerData.newPassword)
  }
}

/**
 * 对注册表单数据进行处理，加密密码字段
 * @param {Object} passwordData - 注册表单数据
 * @returns {Object} 处理后的数据
 */
export function processChangePasswordData(passwordData) {
  return {
    ...passwordData,
    oldPassword: encryptPassword(passwordData.oldPassword),
    newPassword: encryptPassword(passwordData.newPassword)
  }
}
